var React = require('react');

function CalendarTimeZone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM9.46487 8C9.80521 7.41165 10 6.72857 10 6C10 4.51944 9.1956 3.22675 8 2.53513V3C8 3.5 7.5 4 7 4C6.5 4 6.25 4.25 6 4.5C5.75 4.75 5.5 5 5 5H3.5C3.19357 5 2.69933 4.62439 2.36258 4.33357C2.12979 4.84088 2 5.40528 2 6C2 7.86384 3.27477 9.42994 5 9.87398V9C5 8.78725 4.83195 8.4351 4.64601 8.04545C4.20767 7.1269 3.66991 6 5 6H7.5C7.75 6 8 6.5 8.25 7C8.5 7.5 8.75 8 9 8H9.46487Z","fill":"currentColor"}));
}

CalendarTimeZone.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CalendarTimeZone;

CalendarTimeZone.default = CalendarTimeZone;
